export default {
    API_URL: 'https://api.tecnoclub.org/'
}